export const TEMPLATE_OPTION_VALUE = {
  contract: "CONTRACT",
  booking: "BOOKING",
  loading: "LOADING",
  shipment: "SHIPMENT",
};
